import { Container, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CollapsibleHelpSection from '../components/common/CollapsibleHelpSection';
import PageMeta from '../components/common/PageMeta';
import LegalPageStructuredData from '../components/common/LegalPageStructuredData';
import { isBillingEnabled } from '../utils/config';

export default function Privacy() {
  const { t } = useTranslation();

  return (
    <>
      <PageMeta titleKey="privacy.title" descriptionKey="privacy.meta_description" path="privacy" llmsDescribedBy />
      <LegalPageStructuredData page="privacy" />
      <Container className="mt-4">
      <h1 className="mb-4">
        <i className="fas fa-shield-alt text-primary me-2"></i>
        {t('privacy.title')}
      </h1>

      <CollapsibleHelpSection
        titleKey="privacy.how_to_use_title"
        descriptionKey="privacy.how_to_use_desc"
        storageKey="privacy_page"
        defaultExpanded={false}
      />

      <Card>
        <Card.Body>
          <section className="mb-4">
            <h3>{t('privacy.section1_title')}</h3>
            <p>{t('privacy.section1_content')}</p>
            <ul>
              <li>{t('privacy.section1_item1')}</li>
              <li>{t('privacy.section1_item2')}</li>
              <li>{t('privacy.section1_item3')}</li>
              <li>{t('privacy.section1_item4')}</li>
              <li>{t('privacy.section1_item5')}</li>
            </ul>
          </section>

          <section className="mb-4">
            <h3>{t('privacy.section2_title')}</h3>
            <p>{t('privacy.section2_content')}</p>
            <ul>
              <li>{t('privacy.section2_item1')}</li>
              <li>{t('privacy.section2_item2')}</li>
              <li>{t('privacy.section2_item3')}</li>
              <li>{t('privacy.section2_item4')}</li>
              <li>{t('privacy.section2_item5')}</li>
            </ul>
          </section>

          <section className="mb-4">
            <h3>{t('privacy.section3_title')}</h3>
            <p>{t('privacy.section3_content')}</p>
          </section>

          <section className="mb-4">
            <h3>{t('privacy.section4_title')}</h3>
            <p>{t('privacy.section4_content')}</p>
            <ul>
              <li>{t('privacy.section4_item1')}</li>
              <li>{t('privacy.section4_item2')}</li>
              <li>{t('privacy.section4_item3')}</li>
              <li>{t('privacy.section4_item4')}</li>
            </ul>
          </section>

          <section className="mb-4">
            <h3>{t('privacy.section5_title')}</h3>
            <p>{t('privacy.section5_content')}</p>
            <ul>
              {t('privacy.section5_item1') && <li>{t('privacy.section5_item1')}</li>}
              {t('privacy.section5_item2') && (
                <li>
                  {isBillingEnabled()
                    ? t('privacy.section5_item2')
                    : t('privacy.section5_item2_free', {
                        defaultValue:
                          '運営者に故意または重大な過失がある場合であっても、運営者の損害賠償責任の範囲は、法律の定めるところによります。',
                      })}
                </li>
              )}
              {t('privacy.section5_item3') && <li>{t('privacy.section5_item3')}</li>}
            </ul>
          </section>

          <section className="mb-4">
            <h3>{t('privacy.section6_title')}</h3>
            <p>{t('privacy.section6_content')}</p>
          </section>

          <section className="mb-4">
            <h3>{t('privacy.section7_title')}</h3>
            <p>{t('privacy.section7_content')}</p>
          </section>

          <section className="mb-4">
            <h3>{t('privacy.section8_title')}</h3>
            <p>{t('privacy.section8_content')}</p>
          </section>

          <section className="mb-4">
            <h3>{t('privacy.section9_title')}</h3>
            <p>{t('privacy.section9_content')}</p>
            <p>
              <strong>{t('privacy.section9_email')}</strong>
              {t('privacy.section9_phone') && (
                <>
                  <br />
                  <strong>{t('privacy.section9_phone')}</strong>
                </>
              )}
            </p>
          </section>

          <div className="text-muted mt-4">
            <p>
              <strong>{t('privacy.enacted_date')}</strong><br />
              <strong>{t('privacy.last_updated')}</strong>
            </p>
          </div>
        </Card.Body>
      </Card>
    </Container>
    </>
  );
}

